module.exports = __webpack_public_path__ + "static/media/Costbanner@3x.04da13dd.png";